import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { IonItemSliding, ModalController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { TicketZeit } from '../../_interfaces/TicketTime';
import { EditArt } from '../../_interfaces/EditArt';
import { HttpFunctionResult } from '../../_interfaces/HttpFunctionResult';
import { Ticket, TicketBase } from '../../_interfaces/ticket';
import { WorkstepBase } from '../../_interfaces/workstep';
import { DarkmodeService } from '../../_provider/darkmode.service';
import { GeneralService } from '../../_provider/general.service';
import { TicketEditService } from '../../_provider/ticket-edit.service';
import { TicketEmployee } from '../../_provider/tickets/ticket.service';
import { ZeitenService } from '../../_provider/zeiten.service';
import { PopoverListItem, PopoverPage } from '../popover/popover.page';
import { TimeOverviewBasePage } from '../time-overview/time-overview-base/time-overview-base.page';
import { FeedbackService } from 'src/app/_provider/feedback.service';
import { AuthService } from 'src/app/_provider/auth.service';

export interface MetaProperties{
  hex: string
  rgba: string
  icon: string
  text: string
}

@Component({
    selector: 'app-ticket-base-home',
    templateUrl: './ticket-base-home.component.html',
    styleUrls: ['./ticket-base-home.component.scss'],
    standalone: false
})
export class TicketBaseHomeComponent implements OnInit {

  @Input() isMobile: boolean = true 
  @Input() ticket: TicketBase
  @Input() pinned: boolean = false
  @Input() showIsObserver: boolean = false
  @Output() ticketClicked: EventEmitter<TicketBase> = new EventEmitter<TicketBase>(null)
  @Output() onDelete: EventEmitter<TicketBase> = new EventEmitter<TicketBase>(null)
  @Output() onPin: EventEmitter<{toPin: boolean, ticket: TicketBase}> = new EventEmitter<{toPin: boolean, ticket: TicketBase}>(null)

  private timerSub: Subscription
  private startExternalSub: Subscription

  public startLoading: boolean = false

  public priority: MetaProperties
  public status: MetaProperties


  @ViewChild("start", {static: true}) startRef: ElementRef
  @ViewChild("stop", {static: true}) stopRef: ElementRef
  @ViewChild("sliding", {static: true}) sliding: IonItemSliding

  public now: Date = new Date()

  public get isMyTime(){
    return this.activeTimes.some(at => at.time.employeeId == +this.authSrv.getUser().id)
  }

  constructor(
    public darkmode: DarkmodeService,
    public general: GeneralService,
    private authSrv: AuthService,
    public timeSrv: ZeitenService,
    public ticketSrv: TicketEmployee.TicketService,
    private feedback: FeedbackService,
    private modalCtrl: ModalController,
    private ticketEditSrv: TicketEditService,
  ) { 
    this.timerSub = this.timeSrv.timer().subscribe(()=> this.now = new Date())
  }
  
  ngOnDestroy(){
    if(this.timerSub) this.timerSub.unsubscribe()
  }
  
  ngOnInit() {    
    //Priorität werte zuweisen
    switch (this.ticket?.priority) {
      case "Niedrig": 
        this.priority = {hex: "var(--green)", rgba: "rgba(var(--greenRGB), 0.7)", icon: "fa-arrow-down-right", text: `Niedrig`}
        break
      case "Mittel": 
        this.priority = {hex: "var(--yellow)", rgba: "rgba(var(--yellowRGB), 0.7)", icon: "fa-arrow-right", text: `Mittel`}
        break
      default: 
        this.priority = {hex: "var(--red)", rgba: "rgba(var(--redRGB), 0.7)", icon: "fa-arrow-up-right", text: `Hoch`}
        break
    }

    //muss nach arbeitsschritten geschaut werden und nicht nach ticket
    // const time: TicketZeit = this.timeSrv.getTimeByTicket(this.ticket)
    // if(time !== null)  this.ticket.timeFrom = time.timeFrom
  }

  // public get isCurrentlyPinned(){
  //   return this.ticketSrv.pinnedTicketIds.find(id=>id == this.ticket.id) && !this.pinned
  // }

  public async startTimeByTicket(event: any){
    //damit nicht das click ding emittet
    event.stopPropagation()
    this.feedback.vibrate()
    
    this.startLoading = true
   const workstepResult: HttpFunctionResult<WorkstepBase[]> = await this.ticketSrv.getWorksteps(this.ticket.id)
    if(!workstepResult.success) return

    if (workstepResult.data.length == 1){
      await this.timeSrv.startTicketTime(workstepResult.data[0].id, this.ticket)
      this.startLoading = false
      return
    }

    this.ticketEditSrv.setWorksteps(workstepResult.data)
    this.startLoading = false

    await this.feedback.openPopover<EditArt>(PopoverPage, event, {type: "Worksteps"}, async (result: HttpFunctionResult<EditArt>)=>{
      if(!result.success) return
      await this.timeSrv.startTicketTime(result.data.id, this.ticket)
    })
  }

  public stopTimeByTicket(event: any){
    //damit nicht das click ding emittet
    event.stopPropagation()
    if(this.ticket.timeFrom == null) return
    const startedTime = {
      timeFrom: this.ticket.timeFrom,
      timeTo: new Date(),
      note: ""
    }
    // this.timeSrv.saveTime(startedTime)


    //muss nach arbeitsschritten geschaut werden und nicht nach ticket
    // this.timeSrv.stopTicketTime(startedTime,this.ticket)
  }

  public clicked(event){
    if(event.metaKey || event.ctrlKey) this.ticketSrv.openInNewTab(this.ticket.id)
    else this.ticketClicked.emit(this.ticket)
  }


  public get activeTimes(): { ticket: Ticket; time: TicketZeit; workspaceId?: number; }[]{
    return this.timeSrv.timeTickett.filter(tt => tt.ticket.id == this.ticket.id)
  }


  public async showAllTimes(event: any){
    //damit nicht das click ding emittet
    event.stopPropagation()
    await this.feedback.openModal(TimeOverviewBasePage, {ticketId: this.ticket.id})
  }

  public async deleteTicket(){
    await this.sliding.close()
    if(!(await this.feedback.confirm(`Möchten Sie das Ticket "${this.ticket.description}" wirklich löschen?`, "Löschen", "Abbrechen"))) return
    this.onDelete.emit(this.ticket)
  }
  
  public async pinTicket(){
    this.onPin.emit({toPin: !this.pinned, ticket: this.ticket})
  }

  public async openTicketMenu(event: any){
    event.stopPropagation()
    await this.feedback.openPopover<PopoverListItem>(PopoverPage, event, {
      type: "ticketBaseMenu",
      replaceArt: this.pinned ? {id: 1, description: "Lösen", icon: "fa-unpin"} as PopoverListItem : null
    }, async (result: HttpFunctionResult<PopoverListItem>)=>{
      if(!result.success) return
      if(result.data.id == 1) return await this.pinTicket()
      if(result.data.id == 3) return await this.ticketSrv.openInNewTab(this.ticket.id)
      else return await this.deleteTicket()
    })
  }

}
